"use client";
import { useState } from "react";
const faqs = [
    {
        question: "Who is the best urologist in Patna?",
        answer: "HDNA Aarogyam Hospital houses experienced and skilled urology specialists known for their advanced treatment approach, minimally invasive techniques, and patient-focused care.",
    },
    {
        question: "What is the cost of kidney stone treatment in Patna?",
        answer: "The cost depends on the size, location, and type of procedure required (such as URS, PCNL, or laser lithotripsy). We provide transparent pricing after proper medical evaluation.",
    },
    {
        question: "Are minimally invasive urology surgeries safe?",
        answer: "Yes, minimally invasive urology procedures are safe, effective, and offer faster recovery with less pain and shorter hospital stay when performed by experienced surgeons.",
    },
    {
        question: "When should I consult a urologist?",
        answer: "You should consult a urologist if you experience symptoms such as blood in urine, severe lower abdominal pain, frequent urination, difficulty passing urine, urinary leakage, or recurrent UTIs.",
    },
    {
        question: "What types of kidney stone treatments are available at HDNA Aarogyam Hospital?",
        answer: "We offer advanced treatments including laser stone removal, ureteroscopy (URS), PCNL, and other minimally invasive procedures based on the patient’s condition.",
    },
    {
        question: "Do you provide treatment for enlarged prostate (BPH)?",
        answer: "Yes, we provide medical and minimally invasive surgical treatment for enlarged prostate (BPH), along with prostate cancer screening and advanced diagnostic evaluation.",
    },
    {
        question: "Can recurrent urinary tract infections (UTIs) be permanently treated?",
        answer: "Yes, our specialists identify the underlying cause of recurrent UTIs and provide targeted treatment along with preventive care and lifestyle guidance to reduce recurrence.",
    },
    {
        question: "Do you treat male infertility and sexual health problems?",
        answer: "Yes, our urology department offers confidential evaluation and treatment for male infertility, erectile dysfunction, and other reproductive health concerns.",
    },
    {
        question: "Is pediatric urology treatment available?",
        answer: "Yes, we provide specialized care for congenital and acquired urinary disorders in children with a patient-friendly and compassionate approach.",
    },
    {
        question: "Does the hospital provide emergency urology services in Patna?",
        answer: "Yes, HDNA Aarogyam Hospital offers 24/7 emergency urology care for conditions such as severe kidney pain, urinary retention, trauma, or acute infections.",
    }
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
